import { render, staticRenderFns } from "./m_nav.vue?vue&type=template&id=a561145e&scoped=true&"
import script from "./m_nav.vue?vue&type=script&lang=js&"
export * from "./m_nav.vue?vue&type=script&lang=js&"
import style0 from "./m_nav.vue?vue&type=style&index=0&id=a561145e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a561145e",
  null
  
)

export default component.exports